/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the status of the exposure for an asset class.
 * - overweight: the exposure is above target
 * - underweight: the exposure is below target
 * - on_target: the exposure is in the expected range
 * @export
 */
export const ExposureStatus = {
    OVERWEIGHT: 'overweight',
    UNDERWEIGHT: 'underweight',
    ON_TARGET: 'on_target'
} as const;
export type ExposureStatus = typeof ExposureStatus[keyof typeof ExposureStatus];


export function instanceOfExposureStatus(value: any): boolean {
    for (const key in ExposureStatus) {
        if (Object.prototype.hasOwnProperty.call(ExposureStatus, key)) {
            if (ExposureStatus[key as keyof typeof ExposureStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExposureStatusFromJSON(json: any): ExposureStatus {
    return ExposureStatusFromJSONTyped(json, false);
}

export function ExposureStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExposureStatus {
    return json as ExposureStatus;
}

export function ExposureStatusToJSON(value?: ExposureStatus | null): any {
    return value as any;
}

export function ExposureStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ExposureStatus {
    return value as ExposureStatus;
}

